<tax-modal-header>{{ 'select.manual.input.text' | translate }}</tax-modal-header>

<tax-modal-content>
  <div class="alert">
    <tax-icon name="alert"></tax-icon>
    <div class="alert-message" data-qa="alert-message">
      <p *ngFor="let item of alertMessage | translate | taxTextSeparator: '.'">
        {{ item }}
      </p>
    </div>
  </div>
  <div class="address-form ui-kit-rows-layout">
    <tax-input
      id="street"
      labelText="retail.place.street"
      data-qa-input="street"
      name="street"
      placeholder="retail.place.street.placeholder"
      patternErrorText="retail.place.street.pattern.error"
      [(ngModel)]="street"
      [disabled]="streetDisabled"
      [required]="true"
      [clearable]="true"
      [layoutColumns]="2"
      [pattern]="regExp?.street ?? ''"
    ></tax-input>
    <tax-input
      id="house"
      labelText="retail.place.house"
      data-qa-input="house"
      name="house"
      inputStyles="max-width: 128px"
      helpText="kkms.retail.place.create.form.house.help"
      placeholder="retail.place.house.placeholder"
      patternErrorText="retail.place.house.pattern.error"
      [(ngModel)]="house"
      [autofocus]="streetDisabled"
      [required]="true"
      [clearable]="true"
      [layoutColumns]="2"
      [pattern]="regExp?.house ?? ''"
    ></tax-input>
    <tax-input
      id="apartment"
      labelText="retail.place.apartment"
      data-qa-input="apartment"
      name="apartment"
      inputStyles="max-width: 128px"
      helpText="kkms.retail.place.create.form.apartment.help"
      placeholder="retail.place.apartment.placeholder"
      patternErrorText="retail.place.apartment.pattern.error"
      [(ngModel)]="apartment"
      [clearable]="true"
      [layoutColumns]="2"
      [pattern]="regExp?.apartment ?? ''"
    ></tax-input>
  </div>
</tax-modal-content>

<tax-modal-footer>
  <button
    data-qa-button="confirm"
    class="button_blue ui-kit-align-right"
    [disabled]="!formValidation()"
    (click)="confirmChanges(street, house, apartment)"
  >
    {{ 'button.confirm' | translate }}
  </button>
</tax-modal-footer>
